export default __webpack_public_path__ + "static/310-08d78c06bb63867a38c7dc5752272727.gif";